import { Box, Select } from "@mantine/core";
import { useAtom } from "jotai";
import { TFunction } from "react-i18next";

import Button from "components/Button";
import Flex from "components/Flex";
import PageLayout from "components/PageLayout";
import Text from "components/Text";

import { naturalEventAtom } from "atoms/naturalEvents";
import { useClientTranslation } from "hooks/useClientTranslation";
import { useDigitalJourneyPageRouting } from "hooks/useDigitalJourneyPageRouting";
import { useEventTracking } from "hooks/useEventTracking";
import { NaturalEventType } from "types/DigitalJourneySession";

export const getNaturalEvents = (t: TFunction) => {
  return [
    {
      label: "Grandine",
      value: NaturalEventType.HAIL,
    },
    {
      label: "Evento naturale",
      value: NaturalEventType.NATURAL_EVENT,
    },
  ];
};

export const DJTypeOfClaimNaturalEvents = () => {
  const { t } = useClientTranslation();
  const { trackEvent } = useEventTracking();
  const { onNext, continueCTA } = useDigitalJourneyPageRouting();
  const [naturalEvent, setNaturalEvent] = useAtom(naturalEventAtom);
  const isDisabled = naturalEvent === null;

  const onContinue = () => {
    trackEvent({ name: "Digital Journey Type of Claim Natural Events - continue" });

    onNext();
  };

  return (
    <PageLayout contentSpacing="space-between">
      <Flex px={24} py={24} gap={16} flex={1} mb={16}>
        <Text as="h1" sizeVariant="xl" weight={600}>
          Informazioni sul sinistro
        </Text>
        <Box>
          <Flex gap={16} role="radiogroup" aria-labelledby="typeOfClaim">
            <Select
              name="naturalEvent"
              label="Tipo di evento"
              placeholder={t("digital_journey.accident_information.select")}
              data={getNaturalEvents(t)}
              value={naturalEvent}
              onChange={(value) => setNaturalEvent(value as NaturalEventType)}
            />
          </Flex>
        </Box>
      </Flex>
      <Flex px={24} py={24} gap={16}>
        <Button disabled={isDisabled} onClick={onContinue}>
          {continueCTA}
        </Button>
      </Flex>
    </PageLayout>
  );
};
